export const INVESTIGATION_PROCEDURES_LIST_ID = "investigationProceduresList";
export const ATTRIBUTES = [
  {
    id: "title",
    title: "Title",
    type: "STRING",
    filterable: false
  },
  {
    id: "description",
    title: "Description",
    type: "STRING",
    filterable: false
  },
  {
    id: "event_count",
    title: "Event Count",
    type: "INT",
    filterable: false
  },
  {
    id: "risk",
    title: "Risk Score",
    type: "DOUBLE",
    filterable: false
  },
  {
    id: "latest_event_at",
    title: "Latest Alert",
    type: "STRING"
  },
  {
    id: "earliest_event_at",
    title: "Earliest Alert",
    type: "STRING"
  }
];
export const listElements = {
  defaultLayout: {
    entityTableId: INVESTIGATION_PROCEDURES_LIST_ID,
    defaultPageSize: 20,
    defaultSort: { attributeId: "risk", direction: "desc" },
    defaultDisplayedAttributes: ["title", "description", "event_count", "risk", "latest_event_at", "earliest_event_at"],
    defaultColumnOrder: ["title", "description", "event_count", "risk", "latest_event_at", "earliest_event_at"]
  }
};
export const deserializeInvestigationProcedures = (response) => {
  var _a;
  const { total, page, per_page, count, procedures } = response;
  return {
    attributes: ATTRIBUTES,
    list: procedures.map((inProcedure) => {
      var _a2;
      return {
        ...inProcedure.procedure,
        event_count: inProcedure.aggregates.event_count,
        event_ids: inProcedure.aggregates.event_ids,
        risk: (_a2 = inProcedure.aggregates.risk) == null ? void 0 : _a2.avg,
        latest_event_at: inProcedure.aggregates.latest_event_at,
        earliest_event_at: inProcedure.aggregates.earliest_event_at
      };
    }),
    pagination: { total, page, per_page, count },
    meta: { first_procedure_id: (_a = procedures[0]) == null ? void 0 : _a.procedure.id }
  };
};
